import React, { PropsWithChildren } from 'react';
import styled from '@emotion/styled';

import { breakpoints, turquoise } from '~/src/styles';

export const Container = styled.div`
  display: grid;
  grid-template-areas: '. .' '. .';
  row-gap: 24px;
  justify-content: space-between;
  grid-auto-flow: column;

  ${breakpoints.minDesktop} {
    grid-template-areas: '. . . . ';
    column-gap: 40px;
  }
`;

export const TagsContainer = styled.div`
  display: flex;
  color: ${turquoise};
  gap: 12px;
  display: flex;
  align-items: center;
`;

export const MetaInfoContainer: React.FC<PropsWithChildren> & {
  TagsContainer: React.FC<PropsWithChildren>;
} = props => <Container {...props} />;

MetaInfoContainer.TagsContainer = TagsContainer;
